<template>
  <div class="small-banner-content" :style="backbanner">
    <div class="margin-general">
      <div class="img-box">
        <div class="img-content">
          <span class="material-symbols-outlined" translate="no">{{ icon }}</span>
        </div>
      </div>
      <div class="text-box">
        <h1 class="title">{{ title }}</h1>
        <p class="description body-6">{{ description }}</p>
        <p class="description body-6" v-show="descript_1">{{ description2 }}</p>
        <p class="description body-6" v-show="descript_2">{{ description3 }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useImage } from '#imports'; 

const nuxtImg = useImage();

const back1ImageUrl = '/images/forex/invest-gradient.png';
const back2ImageUrl = '/images/forex/BG-mobile.jpg';

const backImageUrl = nuxtImg(back1ImageUrl, {
  quality: 75,
  format: 'webp',
});
const backImageUrl2 = nuxtImg(back2ImageUrl, {
  quality: 75,
  format: 'webp',
});

const backbanner = computed(() => {
  return {
    '--back': `url('${backImageUrl}')`,
    '--back2': `url('${backImageUrl2}')`,
  };
});

const props = defineProps({
  imgBannerGradient: String,
  icon: String,
  title: String,
  description: String,
  description2: String,
  description3: String,
  descript_1: Boolean,
  descript_2: Boolean,
});
</script>
